import _ from 'lodash';
import { connect } from 'react-redux';
import { add, update, get, test, searchHistory } from '../modules/notificationJob';
import { bindActionCreators } from 'redux';
import { showErrors } from '../modules/general';

const mapStateToProps = (state, ownProps) => {
	let notificationJob;
	let id;

	if (ownProps.notificationJob) {
		notificationJob = ownProps.notificationJob;
		id = notificationJob.notificationJobId;
	} else {
		id = _.get(ownProps, ['match', 'params', 'id']);
		notificationJob = id ? _.get(state.maps, ['notificationJob', id]) : undefined;
	}

	let notificationHistoryList = [];
	/** @namespace state.lists.notificationHistoryIds **/
	/** @namespace state.lists.notificationHistory **/

	if (state.lists.notificationHistoryIds && state.lists.notificationHistoryIds[id]) {
		notificationHistoryList = _.map(
			state.lists.notificationHistoryIds[id],
			(id) => state.maps.notificationHistory[id]
		);
	}

	return {
		notificationJob,
		notificationHistoryList,
		stationMap: state.maps.station,
		userMap: state.maps.user,
		authUser: state.auth.authUser,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			searchHistory: searchHistory,
			getNotificationJob: get,
			addNotificationJob: add,
			updateNotificationJob: update,
			testNotificationJob: test,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
